import { render } from "./FullLoading.vue?vue&type=template&id=9b891174&scoped=true"
import script from "./FullLoading.vue?vue&type=script&lang=js"
export * from "./FullLoading.vue?vue&type=script&lang=js"

import "./FullLoading.vue?vue&type=style&index=0&id=9b891174&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9b891174"

export default script